import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { Link } from 'react-router-dom';
import { Form, Formik } from "formik";
import { useQuery } from "react-query";

import * as PR from "../../prime-modules/index";
import Layout from "../../components/layout/Layout";
import Input from "../../components/input";
import { forgotPasswordValidationSchema } from "../../utils/schema";
import { forgotPassword } from "../../services/affiliateApi";
import { globalConfig } from "../../constants";

const ForgotPassword = () => {
    const toast = useRef();
    const {affiliate} = useSelector(state=>state.language?.activelang);
    const emailRef = useRef(null)

    const {  isLoading: bundleListLoading, error: emailError, refetch } = useQuery({
        queryFn: () => forgotPassword(emailRef.current),
        onSuccess: () => toast.current.show({ life: globalConfig?.toastDisplayTime, severity:"success", summary: 'Success', detail: affiliate?.AFFNL0127 }),
        enabled: false
    });

    const handleSubmit = (value, { resetForm }) => {
     emailRef.current = value?.email
     refetch()
     resetForm();
    };

    return (
        <Layout>
           <PR.Toast ref={toast} />
          <section className="signup-section">
            <div className="grid">
              <div className="col-12 text-center">
                <h1>{affiliate?.AFFNL0005}</h1>
                <p>
                  {affiliate?.AFFNL0036}
                </p>
                <div className="signup-wrapper">
                  {/* Form section starts here */}
                  <Formik
                    initialValues={{
                      email: "",
                    }}
                    validationSchema={forgotPasswordValidationSchema}
                    onSubmit={handleSubmit}
                  >
                    <Form autoComplete="off" className="form-block">
                      <div className="grid">
                        <div className="col-12 md:col-12">
                            <Input
                              label={affiliate?.AFFNL0006}
                              name={"email"}
                              type={"email"}
                              aria-describedby={"email"}
                              placeholder={affiliate?.AFFNL0037}
                            />
                        </div>
                        <div className="col-12 mb-4 pb-0">
                          {emailError && (
                            <span className="err-msg">
                              {affiliate[emailError.message]}
                            </span>
                          )}
                          <PR.Button
                            label={affiliate?.AFFNL0039}
                            type="submit"
                            disabled={bundleListLoading}
                            className="signup-button w-12"
                          />
                        </div>
                      </div>
                      <p className="link-p">
                        {affiliate?.AFFNL0015} <Link to="/affiliate-signup">{affiliate?.AFFNL0038}</Link>
                      </p>
                    </Form>
                  </Formik>
                  {/* Form section ends here */}
                </div>
              </div>
            </div>
          </section>
        </Layout>
    );
};

export default ForgotPassword;